'use client';

export default function ErrorPage({ error, reset }) {
  console.error(error);
  const message = String(error?.message || 'Error'); // i18n-guard-ignore
  return (
    <main className="min-h-screen flex flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="text-red-600 font-bold text-xl">
        Load error: {message}{/* i18n-guard-ignore */}
      </p>
      {typeof reset === 'function' ? (
        <button
          type="button"
          onClick={() => reset()}
          className="rounded-xl border border-slate-400 bg-white px-4 py-2 text-sm font-semibold text-slate-800"
        >
          Retry{/* i18n-guard-ignore */}
        </button>
      ) : null}
    </main>
  );
}
